import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'app-avatar',
  standalone: true,
  template: `{{ initials() }}`,
  host: {
    '[style.background-color]': 'backgroundColor()',
  },
  styles: `
    :host {
      align-items: center;
      border-radius: 50%;
      color: white;
      display: inline-flex;
      flex: 0 0 auto;
      font-size: 12px;
      font-weight: 700;
      height: 32px;
      justify-content: center;
      line-height: 1;
      width: 32px;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AvatarComponent {
  readonly name = input('');
  private readonly colors = ['#007c91', '#c04b21', '#4d6b26', '#365f91', '#9b3e67'];

  protected readonly initials = () => {
    const words = this.name().trim().split(/\s+/).filter(Boolean);
    return words[0]?.[0]?.toUpperCase() || '?';
  };

  protected readonly backgroundColor = () => {
    const name = this.name();
    const hash = Array.from(name).reduce(
      (value, character) => ((value * 31) + character.charCodeAt(0)) >>> 0,
      0
    );
    return this.colors[hash % this.colors.length];
  };
}
